import { ofType } from "redux-observable";
import { EMPTY, from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { selectOwnPlayerProfileInfo } from "../../../selectors/selectPlayerInfo";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionSetCurrentPlayerProfile, TypeActionPlayerProfile } from "../actionPlayerProfile";
export var epicOpenOwnPlayerProfile = function (action$, state$) {
    return action$.pipe(ofType(TypeActionPlayerProfile.OpenOwnPlayerProfile), switchMap(function () {
        var state = state$.value;
        var ownInfo = selectOwnPlayerProfileInfo(state);
        if (ownInfo !== undefined) {
            return from([
                actionSetCurrentPlayerProfile(ownInfo.id, ownInfo.level, ownInfo.name, ownInfo.profileIcon, ownInfo.playerLeagueId, ownInfo.coopInfo),
                actionModalOpen(IdModal.PlayerProfile),
            ]);
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/epics/epicOpenOwnPlayerProfile.ts
// module id = 2103
// module chunks = 3